import React, { useRef } from 'react'

import Checkbox from '_components/checkbox'
import IconFilter from '_icons/IconFilter'
import { useDialog } from '_hooks'

const SignalsFilter = ({ signals, setSignals }) => {
  const baseRef = useRef(null)
  const targetRef = useRef(null)

  const { dialog, Dialog } = useDialog({
    wrapperNode: baseRef.current,
    targetNode: targetRef.current,
    maxSize: {
      width: 450,
      height: 230,
    },
  })

  const handleToggle = (key) => {
    // perform an OR operation
    setSignals((prev) => {
      const newFalse = Object.fromEntries(Object.entries(prev).map(([key]) => [key, false]))
      return { ...newFalse, [key]: !prev[key] }
    })
  }

  return (
    <div className="filters" ref={baseRef}>
      <button className="filters__initial" ref={targetRef} onClick={dialog.show}>
        <IconFilter fill="#fff" />
        <span>Add Signals</span>
      </button>
      <Dialog>
        <div className="filters-control">
          <div className="filters-control__values mac-scrollbar">
            {Object.entries(signals).map(([key, value]) => (
              <Checkbox
                key={key}
                name={key}
                label={key}
                checked={value}
                onChange={() => handleToggle(key)}
              />
            ))}
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default SignalsFilter
